// @flow

'use strict';

/**
 * Based off of [the offical Google document](https://developers.google.com/maps/documentation/utilities/polylinealgorithm)
 *
 * Some parts from [this implementation](http://facstaff.unca.edu/mcmcclur/GoogleMaps/EncodePolyline/PolylineEncoder.js)
 * by [Mark McClure](http://facstaff.unca.edu/mcmcclur/)
 *
 * @module polyline
 */

const polyline: typeof polyline = {};

function py2_round(value) {
  // Google's polyline algorithm uses the same rounding strategy as Python 2, which is different from JS for negative values
  return Math.floor(Math.abs(value) + 0.5) * (value >= 0 ? 1 : -1);
}

function encode(current, previous, factor) {
  current = py2_round(current * factor);
  previous = py2_round(previous * factor);
  let coordinate = (current - previous) * 2;
  if (coordinate < 0) {
    coordinate = -coordinate - 1;
  }
  let output = '';
  while (coordinate >= 0x20) {
    output += String.fromCharCode((0x20 | (coordinate & 0x1f)) + 63);
    coordinate /= 32;
  }
  output += String.fromCharCode((coordinate | 0) + 63);
  return output;
}

/**
 * Encodes the given [latitude, longitude] coordinates array.
 *
 * @param {Array.<Array.<Number>>} coordinates
 * @param {Number} precision
 * @returns {String}
 */
polyline.encode = function (coordinates, precision) {
  if (!coordinates.length) {
    return '';
  }

  const factor = Math.pow(10, Number.isInteger(precision) ? precision : 5);
  let output =
    encode(coordinates[0][0], 0, factor) + encode(coordinates[0][1], 0, factor);

  for (let i = 1; i < coordinates.length; i++) {
    const a = coordinates[i],
      b = coordinates[i - 1];
    output += encode(a[0], b[0], factor);
    output += encode(a[1], b[1], factor);
  }

  return output;
};

export { polyline };
